import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest, IFactoryResponse, ITrainingLocation, ITeam } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import useAxios from '@/services/api/useAxios'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'

const resource = 'trainingLocations'

const getAll = (axios: IFactoryFunctionRequest) => ({ firmId }: { firmId: string }): IFactoryResponse<Array<ITrainingLocation>> => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/firm/${firmId}`,
  })
}

const addOne = (axios: IFactoryFunctionRequest) => (trainingLocation: Pick<ITrainingLocation, 'display' | 'address'> | Omit<ITrainingLocation, '_id' | 'isDeleted' | 'modifiedBy'>): IFactoryResponse<ITrainingLocation> => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/create`,
    data: {
      display: trainingLocation.display,
      address: trainingLocation.address,
    },
  })
}

const update = (axios: IFactoryFunctionRequest<ITrainingLocation, { display: string; address?: string }>) => (id: string, data: { display: string; address?: string }) => {
  return axios({
    method: EMethod.patch,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/update/${id}`,
    data,
  })
}

const deleteOne = (axios: IFactoryFunctionRequest<unknown, undefined>) => (id: string) => {
  return axios({
    method: EMethod.delete,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/delete/${id}`,
  })
}

const filter = (axios: IFactoryFunctionRequest<Array<Pick<ITeam, '_id' | 'display'>>, undefined>) => ({
  page = 0,
  display = '',
  limit = 30,
}: { page?: number; display?: string; limit?: number }) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/filter`,
    query: { page, display, limit },
  })
}

export default (axios: AxiosInstance) => ({
  getAll: getAll(useAxios(axios)),
  addOne: addOne(useAxios(axios)),
  update: update(useAxios(axios)),
  deleteOne: deleteOne(useAxios(axios)),
  filter: filter(useAxios(axios)),
})
